<app-modal [open]="active" [name]="'allbids'" (close)="closeDialog()">
  <div modal-header>Submit All Quotes?</div>
  <div modal-body>
    <div>
      {{
        "Clicking “Submit All Quotes” will send " +
          numberOfBids +
          " quote(s) for review."
      }}
      <br /><br />
      Do you wish to continue?
    </div>
    <!-- Itemized confirmation (mockup plate 07). Only renders once the host
         supplies `siteDetails`; the existing single-submit hosts
         (info-header, project-overview-header) pass none, so they keep the
         bare sentence above unchanged. -->
    <app-bulk-item-list
      *ngIf="siteDetails?.length"
      [rows]="siteDetails!"
      testIdPrefix="allbids"
      listLabel="Quotes to submit"
    ></app-bulk-item-list>
    <requirements-acknowledgement
      #reqAck
      [projectRequirements]="data?.specialQuoteRequirements"
      [showSite]="false"
      [hasSiteRequirements]="hasAnySiteRequirements">
    </requirements-acknowledgement>
    <div class="allbids-dialog__summary">
      <div class="allbids-dialog__summary-item">
        <p class="allbids-dialog__summary-label">Project</p>
        <p class="allbids-dialog__summary-value">
          {{ "Project ID: " + (data?.projectOrderId ?? "") }}
        </p>
      </div>
    </div>
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--primary"
    data-testid="allbids-confirm"
    (click)="submit()"
    [disabled]="isSubmitting || (reqAck?.requiresAcknowledgement && !reqAck?.acknowledged)"
  >
    Submit All Quotes
  </button>
  <button
    modal-footer
    type="button"
    class="btn btn--secondary"
    data-testid="allbids-cancel"
    (click)="closeDialog()"
  >
    Cancel
  </button>
</app-modal>
